export type BuyWithConfidenceProps = {
  data: Array<{name: string; description: string;}>;
  classes?: string;
};

export const START_INDEX = 51;
